import { render, staticRenderFns } from "./orderddt_listpage.vue?vue&type=template&id=67ffeec2&"
import script from "./orderddt_listpage.vue?vue&type=script&lang=js&"
export * from "./orderddt_listpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports